export {
  default as immutable,
  serialize as immutableSerialize,
} from './immutable';
